import { useTranslation } from "react-i18next";
import { Camera, Upload } from "lucide-react";
import { Avatar, AvatarFallback } from "../ui/avatar";
import { API_BASE_URL } from "../../services/api";

const toUploadUrl = (path) => {
  const clean = path.startsWith('/') ? path : `/${path}`;
  return API_BASE_URL.startsWith('http') ? `${API_BASE_URL}${clean}` : clean;
};

const resolvePhotoSrc = (p) => {
  if (!p) return null;
  if (p.startsWith("http")) return p;
  if (p.startsWith("/uploads") || p.startsWith("uploads/")) return toUploadUrl(p);
  if (p.startsWith("/assets/")) return p;
  return toUploadUrl(`/uploads/employees/${p}`);
};

const EmployeePhotoSection = ({ photoPreview, selectedEmployee, uploadingPhoto, handlePhotoUpload }) => {
  const { t } = useTranslation();
  const photoUrl = selectedEmployee?.photo_url || selectedEmployee?.picture_url;
  const resolvedPhotoSrc = resolvePhotoSrc(photoUrl);

  return (
    <div className="flex items-center space-x-6">
      <div className="flex-shrink-0">
        <div className="relative">
          <Avatar className="h-40 w-40">
            {photoPreview ? (
              <img src={photoPreview} alt="Preview" className="object-cover" />
            ) : resolvedPhotoSrc ? (
              <img
                src={resolvedPhotoSrc}
                alt="Photo"
                className="object-cover"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
              />
            ) : (
              <AvatarFallback className="text-2xl">
                <Camera className="h-8 w-8" />
              </AvatarFallback>
            )}
          </Avatar>
          <label className="absolute bottom-0 right-0 bg-primary rounded-full p-2 cursor-pointer hover:bg-primary/90 transition-colors">
            <Upload className="h-4 w-4 text-primary-foreground" />
            <input type="file" accept="image/*" onChange={handlePhotoUpload} className="hidden" disabled={uploadingPhoto} />
          </label>
        </div>
      </div>
      <div className="flex-1">
        <h3 className="font-medium">{t("employeesPage.sections.profilePhoto")}</h3>
        <p className="text-sm text-muted-foreground">{t("employeesPage.descriptions.addPhotoInstruction")}</p>
        {uploadingPhoto && (
          <div className="flex items-center space-x-2 mt-2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary" />
            <span className="text-sm">{t("employeesPage.messages.uploadingPhoto")}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeePhotoSection;
